require.register("app/restaurant/analyse/synthesis/ShowModal", function(exports, require, module){
  $0
  
});

